import type { RephraseBlockData } from "./types";

const MAX_PREVIOUS_RESPONSES = 10;

/**
 * Extracts previous responses from rephrase data for use in retry requests.
 * Filters out in-progress items, extracts string data, and limits to last 10 responses
 * to prevent context window overflow.
 */
export const extractPreviousResponses = (rephrasedData: RephraseBlockData[]): string[] => {
	return rephrasedData
		.filter((item) => !item.inProgress && item.data && item.data.length > 0)
		.map((item) => {
			if (typeof item.data === "string") return item.data;
			if (Array.isArray(item.data)) return item.data[0] ?? "";
			return String(item.data);
		})
		.filter((text) => text.length > 0)
		.slice(-MAX_PREVIOUS_RESPONSES);
};
